import React, { useEffect, useState } from 'react';
import { TESTIMONIALS } from '../data/mock';
import Reveal from './Reveal';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setIndex((i) => (i + 1) % TESTIMONIALS.length),
      6000
    );
    return () => clearInterval(t);
  }, []);

  const prev = () =>
    setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setIndex((i) => (i + 1) % TESTIMONIALS.length);

  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0705] to-[#0a0705]" />
      <div className="relative max-w-4xl mx-auto text-center">
        <Reveal>
          <p className="text-[10px] tracking-[0.5em] text-[#c8935a] font-fell-sc">
            WHISPERS FROM THE ACCUSED
          </p>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-12 min-h-[220px] md:min-h-[200px] relative">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                className={`absolute inset-0 flex flex-col items-center justify-center transition-opacity duration-[1200ms] px-4 ${
                  i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
              >
                <Quote className="w-6 h-6 text-[#c8935a]/50 mb-6" />
                <p className="font-fell italic text-2xl md:text-3xl leading-relaxed text-[#e8dcc0] max-w-2xl">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <p className="mt-6 font-fell-sc text-[10px] tracking-[0.4em] text-[#8b7355] uppercase">
                  — {t.attribution}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-10 flex items-center justify-center gap-6">
            <button
              onClick={prev}
              aria-label="previous"
              className="text-[#8b7355] hover:text-[#c8935a] transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  aria-label={`quote ${i + 1}`}
                  className={`h-[2px] transition-all duration-500 ${
                    i === index ? 'w-8 bg-[#c8935a]' : 'w-4 bg-[#3a2818]'
                  }`}
                />
              ))}
            </div>
            <button
              onClick={next}
              aria-label="next"
              className="text-[#8b7355] hover:text-[#c8935a] transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
